export const foreignLaborRecruiterMappingTo9142BAppxC = {
  name: "Foreign Labor Recruiter Profile Form Mapping",
  machine_name: "foreign_labor_recruiter_9142B_profile_mapping",
  targetFormDetailName: "Form ETA-9142B",
  targetSectionName: "appendixC",
  targetSectionLabel: "appendixC",
  fields: [
    {
      profileFieldName: "new_profile_fl_recr_last_name",
      formTargetField: "apdxcRecLastname",
    },
    {
      profileFieldName: "new_profile_fl_recr_first_name",
      formTargetField: "apdxcRecFirstname",
    },
    {
      profileFieldName: "new_profile_fl_recr_middle_name",
      formTargetField: "apdxcRecMiddlename",
    },
    {
      profileFieldName: "new_profile_fl_recr_employer_name",
      formTargetField: "apdxcRecOrg",
    },
    {
      profileFieldName: "new_profile_fl_recr_city",
      formTargetField: "apdxcRecCity",
    },
    {
      profileFieldName: "new_profile_fl_recr_state_id",
      formTargetField: "apdxcRecState",
    },
    {
      profileFieldName: "new_profile_fl_recr_zip",
      formTargetField: "apdxcRecPostcode",
    },
    {
      profileFieldName: "new_profile_fl_recr_country_id",
      formTargetField: "apdxcRecCountry",
    },
    {
      profileFieldName: "new_profile_fl_recr_province",
      formTargetField: "apdxcRecProvince",
    },
  ],
};
